import React, { useState, useEffect } from 'react';
import AdminSidebar from './AdminSidebar';
import '../../styles/AdminLayout.scss';

const AdminLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) setIsSidebarOpen(false);
      else setIsSidebarOpen(true);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`admin-layout ${isSidebarOpen ? 'sidebar-open' : 'sidebar-collapsed'}`}>
      {/* Mobile Toggle Button — shown only when sidebar is closed on mobile */}
      {isMobile && !isSidebarOpen && (
        <button
          className="mobile-sidebar-toggle"
          onClick={() => setIsSidebarOpen(true)}
          aria-label="Open menu"
        >
          ☰
        </button>
      )}

      <AdminSidebar isOpen={isSidebarOpen} onToggle={setIsSidebarOpen} />

      {/* Overlay — shown only on mobile when sidebar is open */}
      {isMobile && isSidebarOpen && (
        <div
          className="mobile-sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <main className="admin-main">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
